<template>
  <filter-header
    :show-filter-mode="showFilterMode"
    :toggle-show-mode="toggleShowMode"
    :has-filter="hasFilter"
    :total-record="staffDisplayList.length"
    :clear-all-filter="clearFilter"
    :label="'staff'"
  >
    <template #query-fields>
      <div class="control is-expanded line staff-center">
        <basic-dropdown
          v-model="centerId"
          :options="centerOption"
          :label="$t('staff.center')"
          @update:model-value="updateCenterId"
        />
      </div>
      <div class="control is-expanded searchWrap display-flex">
        <selection-input
          v-model="searchStaffName"
          :label="$t('staff.search')"
          @update:model-value="updateSearchKey"
        />
        <div class="search-line" />
        <selection-input
          v-model="searchKeyword"
          :label="$t('staff.keywordSearch', 'Search by Keyword')"
          @update:model-value="updateKeywordSearch"
        />
      </div>
    </template>

    <template #query-display>
      <ShowSingleQueryOption
        :lookup-label="centerOption"
        :value="centerId"
        :class-style="'filter document-type'"
        :remove-item="() => { centerId = null;}"
      />
      <ShowQueryText
        :label="'Search'"
        :value="searchStaffName"
        :clear-query-item="() => { searchStaffName = null;}"
        :class-style="'tag is-light filter search-term'"
      />
      <ShowQueryText
        :label="'Keyword Search'"
        :value="searchKeyword"
        :clear-query-item="() => { searchKeyword = null;}"
        :class-style="'tag is-light filter search-keyword'"
      />
    </template>
  </filter-header>

  <section class="section">
    <div class="container pt-0">
      <div
        v-if="staffDisplayList && staffDisplayList.length > 0"
        class="table"
      >
        <div
          class="columns header is-multiline is-mobile is-hidden-touch headings staff-item"
        >
          <div
            v-for="(col, index) in headers"
            :key="index"
            class="column is-3-desktop column-header"
            @click="updateSort(col.key)"
          >
            {{ col.label }}
            <div
              v-if="col.key === sort.columnName"
              class="arrow-button-wrapper"
            >
              <button
                class="
                      teamMemberRowToggle
                      button
                      is-brightGreen is-inverted
                      toggle
                      is-hidden-touch
                      svg nav-arrow-green-16
                      "
                aria-label="change sorting mode"
                :class="{'inactive':sort.isAscendance === false, 'active': sort.isAscendance === true}"
              />
            </div>
          </div>
          <div class="column is-3-desktop" />
        </div>
        <div
          class="table-content-wrapper columns"
          style="padding-right: 0px;"
        >
          <template
            v-for="(item, index) of staffDisplayList"
            :key="'staff' + index"
          >
            <div class="columns is-multiline is-mobile staff-item">
              <div
                class="column is-3-desktop is-12-touch"
                :class="{'clickable': item.hasDetail}"
              >
                <div
                  class="bolded"
                  @click="item.hasDetail && clickDropdown(item)"
                >
                  <template v-if="item.honorific && item.honorific != 'none'">
                    {{
                      item.honorific
                    }}
                  </template>
                  {{ item.fullName }}
                </div>
              </div>
              <div class="column is-3-desktop is-12-touch is-serif">
                {{ item.center }}
              </div>
              <div class="column is-3-desktop is-12-touch is-serif">
                {{ item.roles }}
              </div>
              <div
                class="column is-3-desktop is-12-touch"
              >
                <div
                  v-if="item.email != null"
                  class="email"
                >
                  <a
                    :href="'mailto:' + item.email"
                    class="button is-brightGreen is-inverted svg email-15 right email mt-0"
                    aria-label="click to show email"
                    @click="clickShowEmail(item)"
                  >
                    Email
                  </a>
                  <div class="arrow-button-wrapper">
                    <button
                      v-if="item.hasDetail"
                      class="
                          teamMemberRowToggle
                          button
                          is-brightGreen is-inverted
                          toggle
                          is-hidden-touch
                          svg nav-arrow-green-16
                      "
                      :class="[item.isOpen ? 'active' : 'inactive']"
                      aria-label="show details"
                      @click="clickDropdown(item)"
                    />
                  </div>
                </div>
                <div v-show="item.showEmail">
                  {{ item.email }}
                </div>
                <!--<img :src="item.imagePath">-->
              </div>
              <Transition name="drop">
                <div
                  v-if="item.isOpen"
                  class="column is-12-desktop is-12-touch is-collapsible is-hidden-touch"
                >
                  <!-- :class="{'active': item.isOpen, 'inactive': !item.isOpen}" -->
                  <div>
                    <div class="is-flex">
                      <div class="column is-10-desktop staff-info pl-0">
                        <div
                          v-if="item.description"
                          v-sane-html="item.description"
                          class="mb-4"
                        />

                        <template v-if="item.keywords">
                          <div class="keywords-section">
                            <span class="bolded">Keywords: </span>
                            <div v-if="item.keywordList && item.keywordList.length > 0">
                              <span
                                v-for="(keyword, keywordIndex) in item.keywordList"
                                :key="keywordIndex"
                                class="keyword-link clickable"
                                @click="addKeywordToSearch(keyword)"
                              >
                                {{ keyword }}<span
                                  v-if="keywordIndex < item.keywordList.length - 1"
                                >, </span>
                              </span>
                            </div>
                          </div>
                        </template>

                        <template v-if="item.projectTitles && item.projectTitles.length > 0">
                          <div class="bolded mt-2">
                            <span>Projects: </span>
                            <span
                              v-for="(project, projectIndex) of item.projectTitles"
                              :key="'prj-' + projectIndex + '-link-' + webIndex"
                            >
                              <a
                                :href="project?.path"
                                target="_blank"
                                aria-label="view project"
                              >
                                {{
                                  project?.title
                                }}
                              </a>
                              <span v-if="projectIndex < item.projectTitles.length - 1"> | </span>
                            </span>
                          </div>
                        </template>

                        <template v-if="item.webLinks && item.webLinks.length > 0">
                          <div class="bolded mt-2">
                            Learn more about
                            <template
                              v-if="item.honorific && item.honorific != 'none'"
                            >
                              {{ item.honorific }}
                            </template>
                            {{ item.fullName }}
                          </div>
                          <div
                            v-for="(webLink, webIndex) of item.webLinks"
                            :key="'item-' + index + '-link-' + webIndex"
                          >
                            <a
                              :href="webLink.urlLink"
                              target="_blank"
                              aria-label="view web"
                            >
                              {{
                                webLink.linkText
                              }}
                            </a>
                          </div>
                        </template>
                        <div
                          v-if="item.phoneNumber"
                          class="svg phone-15 mt-1"
                        >
                          {{ item.phoneNumber }}
                        </div>
                        <div
                          v-if="item.officeNumber"
                          class="svg location-dot-15 mt-1"
                        >
                          {{ item.officeNumber }}
                        </div>
                        <div
                          v-if="item.email"
                          class="svg email-15 mt-1"
                        >
                          <a
                            v-show="item.showEmail"
                            :href="'mailto:' + item.email"
                          >{{ item.email }}</a>
                          <a
                            v-show="!item.showEmail"
                            aria-label="click to show email"
                            @click="clickShowEmail(item)"
                          >Email</a>
                        </div>
                      </div>
                      <img
                        v-if="item.image"
                        class="staff-dir-img ml-0"
                        alt="staff image"
                        :src="WEB_HOME_URL + item.imagePath"
                      >
                    </div>
                  </div>
                </div>
              </Transition>
            </div>
          </template>
        </div>
        <div class="staff-counter">
          {{ staffDisplayList && staffDisplayList.length }} <template v-if="staffDisplayList && staffDisplayList.length > 1">
            Staff Members
          </template>
          <template v-else>
            Staff Member
          </template>
        </div>
      </div>
      <div
        v-else
        class="no-matches"
      >
        No staff were found matching the search parameters.
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue';
import ShowSingleQueryOption from '../../components/ShowSingleQueryOption.vue';
import ShowQueryText from '../../components/ShowQueryText.vue';
import FilterHeader from '../../components/FilterHeader.vue';
import BasicDropdown from '../../components/dropdown/BasicDropdown.vue';
import SelectionInput from '../../components/search/SelectionInput.vue';
import abmiStaffApi from '@/services/data/staff-directory.ts';

const WEB_HOME_URL = (import.meta.env.VITE_APP_HOME_URL ?? '');

const headers = [
  { label: 'Name', key: 'fullName' },
  { label: 'Centre', key: 'center' },
  { label: 'Role', key: 'roles' }
];

const centerOption = ref([]);
const staffList = ref([]);
const centerId = ref();
const searchStaffName = ref();
const searchKeyword = ref(); // New searchKeyword field
const showFilterMode = ref(true);

const sort = ref({ columnName: null, isAscendance: null });

const toggleShowMode = () => {
  showFilterMode.value = !showFilterMode.value;
};
const hasFilter = computed(() => {
  return searchStaffName.value != null || centerId.value != null || searchKeyword.value != null; // Check if keyword filter is applied
});

const clearFilter = () => {
  searchStaffName.value = null;
  centerId.value = null;
  searchKeyword.value = null; // Clear keyword filter
};

onMounted(async () => {
  const data = await abmiStaffApi.getAllStaffs('/abmi-staff');
  staffList.value.push(...data.sort((a, b) => {
    if (a.center !== b.center) {
      return (a.center ?? 'zz') > (b.center ?? 'zz') ? 1 : -1;
    }
    if (a.displayOrder === b.displayOrder) {
      return (a.center + a.lastName) > (b.center + b.lastName) ? 1 : -1;
    }
    return +(a.displayOrder ?? 1000) > +(b.displayOrder ?? 1000) ? 1 : -1;
  }));
  staffList.value.forEach((item, index) => {
    if (!centerOption.value.includes(item.center) && item.center != null) {
      centerOption.value.push(item.center);
    }
    item.isOpen = false;
    item.showEmail = false;
    item.id = index;
    item.email = item.name;
    item.fullName = `${item.firstName} ${item.lastName}`;

    if (item.jobTitle) {
      const splitRoles = item.jobTitle.split(',');
      item.roles = splitRoles.join(',\n');
    }

    if (item.webLinkTexts?.['@nodes']?.length > 0) {
      item.webLinks = [];
      item.webLinkTexts?.['@nodes'].forEach(link => {
        item.webLinks.push({ linkText: item.webLinkTexts[link]?.linkText, urlLink: item.webLinkTexts[link]?.urlLink });
      });
    }
    item.webLinkTexts = null;

    item.hasDetail = (item.image != null || item.description != null || item.webLinks?.length > 0 || item.officeNumber != null || item.phoneNumber != null || item.projectTitles?.length > 0);

    if (item.keywords) {
      item.keywordList = item.keywords.toLowerCase().split(',').map(keyword => keyword.trim());
    }
  });
});

const clickShowEmail = (item) => {
  item.showEmail = true;
};
const clickDropdown = (item) => {
  item.isOpen = !item.isOpen;
};

const updateSearchKey = (e) => {
  searchStaffName.value = e;
};
const updateCenterId = (e) => {
  centerId.value = e == null ? null : +e;
};
const updateKeywordSearch = (e) => {
  searchKeyword.value = e;
};

const addKeywordToSearch = (keyword) => {
  searchKeyword.value = keyword;
};

const updateSort = (columnNameName) => {
  if (sort.value.columnName !== columnNameName) {
    sort.value.columnName = columnNameName;
    sort.value.isAscendance = true;
  } else {
    sort.value.isAscendance = !sort.value.isAscendance;
  }
};

const staffDisplayList = computed(() => {
  let tmpList;

  if (typeof centerId.value === 'number' || searchStaffName.value != null || searchKeyword.value != null) {
    const filtered = staffList.value.filter(person => {
      const matchesCenter = (centerId.value == null || person.center === centerOption.value[centerId.value]);
      const matchesName = (searchStaffName.value == null || person.fullName.toUpperCase().includes(searchStaffName.value.toUpperCase()));
      const matchesKeyword = (searchKeyword.value == null || person.keywordList?.some(keyword => keyword.includes(searchKeyword.value.toLowerCase())));

      return matchesCenter && matchesName && matchesKeyword;
    });
    tmpList = filtered;
  } else {
    tmpList = [...staffList.value];
  }

  const { columnName, isAscendance } = sort.value;

  tmpList.sort((a, b) => {
    const r = ((a[columnName] || 'zzz') > (b[columnName] || 'zzz')) ? 1 : -1;
    return r * (isAscendance ? 1 : -1);
  });

  return tmpList;
});
</script>

<style scoped>
.column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding-right: 30px;
  font-size: large;
}
.drop-enter-active {
  transition: all 0.3s ease-out;
}
.drop-leave-active {
  transition: all 0.1s ease-in-out;
}

.drop-enter-from,
.drop-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
.bolded{
    font-weight: bold;
}

.staff-item{
    position: relative;
    margin-right: 0px;
}

.table .table-content-wrapper{
    flex-direction: column;
    overflow-y: auto;
    height:35rem;
}

.staff-counter{
    float:right;
    margin-right:2rem;
}

.container .no-matches{
  text-align: center;
}
/*
.table .table-content-wrapper .staff-item .column:not(.is-collapsible){
  white-space: pre-line;
}*/

.table .column.staff-info ::v-deep p{
  margin-bottom: 1.5rem;
}

.table .column.staff-info {
  margin:0px;
  padding-top: 0px;
}

.table>.columns .column.is-collapsible>div img.staff-dir-img{
  width:150px;
  height:150px;
}

.table .columns .arrow-button-wrapper {
  display:flex;
  flex-direction: column;
  justify-content: center;
}

.table>.columns .arrow-button-wrapper .teamMemberRowToggle {
  top: unset;
  right: unset;
  transform: none;
}

.vcenter{
  display: flex;
  align-items: center;
}

.table>.table-content-wrapper .columns:nth-child(even) {
  background-color: #f6f6f6;
}

.field.is-grouped .control.is-expanded.line:after {
    content: "";
    border-right: 1px solid #bbbbbb;
    display: block;
    height: 40px;
    padding-left: 1.5rem;
    margin-top:-45px;
}
.columns.header .column-header:nth-child(1) {
  padding-left: 0px;
}

.columns.header .column-header:nth-child(2) {
  padding-left: 6px;
}
.columns.header .column-header:nth-child(3) {
  padding-left: 15px;
}

.searchHeader {
  margin-top: -40px;
  font-weight: bold;
  padding-bottom: 10px;
  font-size: large;
}

@media screen and (max-width: 1024px) {  /* Adjust based on your layout and tooltip size */
  .searchHeader {
      margin-top: 0px;
      font-weight: bold;
      padding-bottom: 10px;
      font-size: large;
  }

  .field.is-grouped .control.is-expanded.line:after {
    content: "";
    border-right: 0px solid #bbbbbb;
  }
}
.email {
  display:flex;
  align-items: center;
  justify-content: space-between;
}
a {
  color: #95aa0c;
  &:hover {
    font-weight: 600;
    text-decoration: underline;
  }
}

.search-line {
  border-right: 1px solid #bbbbbb;
  padding-right: 5px;
  margin-right: 5px;
  height: 40px;
}

@media screen and (max-width: 768px) {
  .searchWrap {
    flex-direction: column;
  }

  .search-line {
    display: none;
  }

  .searchForm {
    margin-bottom: 1rem;
  }
}

.display-flex {
  display: flex;
}

section.publicationFilters .filterWrap .control:first-child, section.publicationFilters .filterWrap .control:nth-child(2) {
  width: auto;
}

.keyword-link {
  color: #95aa0c;
}

.keyword-link:hover {
    text-decoration: underline;
}

.comma {
  color:#000
}
</style>
